export default [
  {
    title: "ภาพรวม",
    customIcon: "CustomSVG",
    children: [
      {
        title: "จำนวนคนสมัครสมาชิก",
        route: "custom-module",
        path: "/custom-module/custom-overview-register-summary",
      },
    ],
  },
];
